import script from "./ArchiveDisplayTime.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArchiveDisplayTime.vue?vue&type=script&lang=ts&setup=true"

import "./ArchiveDisplayTime.vue?vue&type=style&index=0&id=63016bb6&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63016bb6"]])

export default __exports__